import { render, staticRenderFns } from "./ChanpinManagement.vue?vue&type=template&id=0892d292&scoped=true&"
import script from "./ChanpinManagement.vue?vue&type=script&lang=js&"
export * from "./ChanpinManagement.vue?vue&type=script&lang=js&"
import style0 from "./ChanpinManagement.vue?vue&type=style&index=0&id=0892d292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892d292",
  null
  
)

export default component.exports